/**
 * Slider/RangeSlider Component Styles
 */

import { mode } from '../../system/color-mode';

export const sliderStyles = {
  baseStyle: {
    container: {
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
    },
    track: {
      overflow: 'hidden',
      borderRadius: 'full',
      bg: 'gray.200',
    },
    filledTrack: {
      bg: 'brand.500',
    },
    thumb: {
      w: 4,
      h: 4,
      borderRadius: 'full',
      bg: 'white',
      boxShadow: 'base',
      _focus: {
        boxShadow: 'outline',
      },
      _disabled: {
        bg: 'gray.300',
      },
    },
    mark: {
      fontSize: 'sm',
      mt: 4,
    },
  },

  sizes: {
    sm: {
      track: { h: '4px' },
      thumb: { w: 3, h: 3 },
    },
    md: {
      track: { h: '8px' },
      thumb: { w: 4, h: 4 },
    },
    lg: {
      track: { h: '12px' },
      thumb: { w: 5, h: 5 },
    },
  },

  variants: {
    main: (props) => ({
      thumb: {
        bg: mode('brand.500', 'brand.400')(props),
      },
      filledTrack: {
        bg: mode('brand.500', 'brand.400')(props),
      },
    }),
  },

  defaultProps: {
    size: 'md',
    colorScheme: 'brand',
  },
};

export default sliderStyles;
